import React from "react";
import "./Confirm.css";
import { Link, useLocation } from "react-router-dom";
import bookconfirmImage from "assets/Images/book.png";
import CheckoutStepper from "component/CheckoutStepper/CheckoutStepper";

const Confirm = () => {
  const { state } = useLocation();
  const verificationData = state?.verificationData;

  if (!verificationData) {
    return (
      <div className="order-confirmation">
        <h2 className="confirmation-title">No Order Data Found</h2>
        <p className="confirmation-message">
          Please make sure you've completed your order properly.
        </p>
      </div>
    );
  }

  return (
    <div className="order-confirmation">
      <CheckoutStepper currentStep={3} />
      <div className="confirmation-box">
        <div className="icon-container">
          <img
            src={bookconfirmImage}
            alt="Order Confirmed Icon"
            className="confirmation-icon"
          />
        </div>
        <h2 className="confirmation-title">Order Confirmed</h2>
        <p className="confirmation-message">
          Your order is confirmed. You will receive an order confirmation email/SMS shortly with the expected delivery date for your items.
        </p>
        <div className="delivery-details">
        <p>
            <strong>Order ID : </strong> {verificationData.quickTransactionId}
          </p>
          <p>
            <strong>{verificationData.customerName}</strong> | {verificationData.customerPhone}
          </p>
          <p>{verificationData.fullAddress}</p>
          <div className="BTn-container">
         
          {verificationData ? (
            <Link to='/userprofile'>
              <p className="details020449">Go to Orders</p>
            </Link>
          ) : (
            <Link to='/cart'>
              <p className="details020449">Go to Cart</p>
            </Link>
          )}
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm;
